export function throttle(func: Function, limit: number) {
  let lastFunc: unknown
  let lastRan: number
  // @ts-ignore
  return function (...args) {
    if (!lastRan) {
      // @ts-ignore
      func.apply(this, args)
      lastRan = Date.now()
    } else {
      clearTimeout(lastFunc as number)
      lastFunc = setTimeout(function () {
        if (Date.now() - lastRan >= limit) {
          // @ts-ignore
          func.apply(this, args)
          lastRan = Date.now()
        }
      }, limit - (Date.now() - lastRan))
    }
  }
}
